import React, { useState, useEffect } from "react";
import { AiOutlineUser, AiOutlineCloudUpload, AiOutlineFileDone, AiOutlineTeam } from "react-icons/ai";
import adminService from "../services/adminService";

export default function AdminDashboard() {
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const response = await adminService.getAdminDashboard();
        if (response.success) {
          setDashboardData(response.data);
        } else {
          setError("Failed to load dashboard data");
        }
      } catch (err) {
        setError("Failed to load dashboard data");
        console.error("Error fetching dashboard data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, []);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "50vh" }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="alert alert-danger text-center" role="alert">
        {error}
      </div>
    );
  }

  const stats = [
    {
      icon: <AiOutlineUser size={28} color="#29addc" />,
      label: "Users Registered",
      color: "#29addc", bg: "#e9fafc", value: dashboardData?.stats?.total_users || 0,
    },
    {
      icon: <AiOutlineTeam size={28} color="#f59e0b" />,
      label: "Employees",
      color: "#f59e0b", bg: "#fef3c7", value: dashboardData?.stats?.total_working_employees || 0,
    },
    {
      icon: <AiOutlineCloudUpload size={28} color="#4f46e5" />,
      label: "Docs Uploaded",
      color: "#4f46e5", bg: "#efebfd", value: dashboardData?.stats?.total_services || 0,
    },
    {
      icon: <AiOutlineFileDone size={28} color="#18e08f" />,
      label: "Tax Forms Finalized",
      color: "#18e08f", bg: "#e8fcf4", value: dashboardData?.stats?.total_requests || 0,
    },
  ];
  return (
    <section>
      <div style={{
        display: "flex",
        flexWrap: "wrap",
        gap: 26,
        marginBottom: 40,
      }}>
        {stats.map((s, i) => (
          <StatCard key={i} {...s} />
        ))}
      </div>
      <div style={{
        background: "#eaf5fb",
        borderRadius: 20,
        minHeight: 220,
        marginTop: 12,
        outline: "2px dashed #79f2e8",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 21,
        color: "#b6d5ec",
        fontWeight: 700,
        letterSpacing: "0.06em"
      }}>
        {/* Placeholder for graphs/analytics */}
        [ Analytics and Graphs will appear here ]
      </div>
    </section>
  );
}

function StatCard({ icon, color, bg, label, value }) {
  return (
    <div style={{
      background: bg,
      color,
      borderRadius: 15,
      minWidth: 200,
      padding: "25px 29px",
      boxShadow: "0 2px 20px #d8edfb39",
      display: "flex",
      flexDirection: "column",
      gap: 8,
      alignItems: "flex-start",
    }}>
      <div>{icon}</div>
      <div style={{ fontWeight: 900, fontSize: 31, color }}>{value}</div>
      <div style={{ color: "#00378e", fontWeight: 600, fontSize: 16 }}>{label}</div>
    </div>
  );
}
